import React, { FC, HTMLAttributes } from 'react';
import styled from 'styled-components/macro';
import media from 'styles/media';
import { WrapText, LinkText } from 'components/atoms';
import * as MESSAGES from 'constants/messages';
import { MissionForInnovator } from 'types/mission';
import { Title } from '../../Typography';

const StrengthPoint = styled(WrapText)`
  min-height: 248px;
  overflow: auto;
  line-height: 26px;

  ${media.tablet} {
    min-height: auto;
  }
`;

type Props = {
  strengthPoint: MissionForInnovator['strengthPoint'] | undefined;
} & HTMLAttributes<HTMLDivElement>;

const StrengthPointField: FC<Props> = ({ strengthPoint, ...rest }) => {
  return (
    <div {...rest}>
      <Title>{MESSAGES.MISSION_CARD.FIELD.STRENGTH_POINT.LABEL}</Title>
      <StrengthPoint>
        <LinkText color="secondary">{strengthPoint ?? '-'}</LinkText>
      </StrengthPoint>
    </div>
  );
};

export default StrengthPointField;
